import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { useImageSrc } from "../../hooks";
import { IMAGES } from "../../themes";
const useStyles = makeStyles(() => ({
  container: ({
    position,
    size
  }) => ({
    position,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    top: `calc(50%-${size / 2})`
  }),
  img: {
    alignSelf: "center",
    width: "100%",
    height: "100%"
  }
}));

const SpinnerBox = ({
  position,
  size,
  color
}) => {
  const styles = useStyles({
    position,
    size
  });
  const spinnerSrc = useImageSrc(IMAGES.SPINNER);
  return /*#__PURE__*/React.createElement(Box, {
    width: size,
    height: size,
    color: color,
    className: styles.container,
    borderRadius: "50%"
  }, /*#__PURE__*/React.createElement("img", {
    src: spinnerSrc,
    alt: "Loader...",
    className: styles.img
  }));
};

SpinnerBox.defaultProps = {
  position: "absolute",
  size: 50,
  color: "primary"
};
export default SpinnerBox;